import cx from 'classnames';
import { memo } from 'react';
import Interpolate from '@wg/wows-react-uikit/components/Interpolate/Interpolate';

import { t } from '~/helpers/localization';

import Countdown from '~/UIKit/Countdown/Countdown';

import styles from './ClanHubTile.module.scss';
import countdownIcon from './images/icon_countdown.png';
import countdownIconAccent from './images/icon_countdown_orange.png';

interface ClanHubTileCountdownProps {
  className?: string;
  endsAtResolved: number;
  endsAtTextLabelResolved?: string | null;
}

const ClanHubTileCountdown = ({ className, endsAtResolved, endsAtTextLabelResolved }: ClanHubTileCountdownProps) => {
  const isCountdownAccent = endsAtResolved != null && endsAtResolved - Date.now() <= 24 * 60 * 60 * 1e3;

  return (
    <div
      className={cx(styles.tileCountdown, className, {
        [styles.accent]: isCountdownAccent,
      })}
    >
      <img
        className={styles.tileCountdownIcon}
        src={isCountdownAccent ? countdownIconAccent : countdownIcon}
        width={13}
        height={13}
      />
      <Interpolate
        str={endsAtTextLabelResolved || t('Ends in %(timeleft)s')}
        timeleft={<Countdown date={endsAtResolved} />}
      />
    </div>
  );
};

export default memo(ClanHubTileCountdown);
